import React from 'react';

const defaultUser = null;
export default React.createContext(defaultUser);
